import React from "react"
import { FlyOutPanel } from "@4cplatform/elements/Molecules"

// Components
import JourneyView from "./journeys.panel.view"

const JourneysPanel = () => <FlyOutPanel body={() => <JourneyView />} name="journeys_panel" />

export default JourneysPanel
